import { triggerInitWishlistTogglers } from "../wishlist/wishlist";

/**
 * Applies correct E0 add to cart button name based on the current customer E0 status
 */
const applyCorrectEntregaZeroButtonText = () => {
    const isSubscriptionExpired = $(".minicart .ct-popover").data("is-entrega-zero-expired");
    const $entregaZeroTile = $(".ct-product-tile--entrega-zero-product");
    if ($entregaZeroTile.length > 0) {
        const $addToCartButton = $entregaZeroTile.find(".js-add-to-cart-tile");
        const $spanActiveSubs = $addToCartButton.find(".active-subscription");
        const $spanExpSubs = $addToCartButton.find(".expired-subscription");

        if (isSubscriptionExpired || isSubscriptionExpired == null) {
            $spanActiveSubs.addClass("d-none");
            $spanExpSubs.removeClass("d-none");
        } else {
            $spanActiveSubs.removeClass("d-none");
            $spanExpSubs.addClass("d-none");
        }
    }
};

/**
 * Init global events
 */
const initEvents = () => {
    /**
     * Event used to trigger page reload
     * Example: for the case when the cart contains only E0 product but no available slot was returned.
     */
    $(document).on("click", ".js-retry", () => {
        window.location.reload();
    });

    /**
     * Event used to prevent default action
     */
    $(document).on("click", ".js-prevent-default", e => {
        e.preventDefault();
    });

    applyCorrectEntregaZeroButtonText();
    triggerInitWishlistTogglers();
};

export { initEvents };
